import { USER_JURISDICTION_QUERY, COUNTRY_JURISDICTION_QUERY, USER_COUNTRY_UPDATED, USER_JURISDICTION_UPDATED, USER_COUNTRY_QUERY } from '@gig/magic-messages';
import { Jurisdiction } from '@gig/magic-jurisdictions/dist/jurisdictions.constants';
import { Country } from '@gig/magic-sdk/dist/adapter/users/getCountries';
import { JurisdictionModulesService } from './jurisdiction-modules.service.js';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const JURISDICTION_FORM_QUERY = "jurisdiction:form:query";
const COUNTRY_TO_JURISDICTION = {
  [Country.UNITED_KINGDOM]: Jurisdiction.UKGC,
  [Country.SWEDEN]: Jurisdiction.SGA,
  [Country.LATVIA]: Jurisdiction.IAUI,
  [Country.ARGENTINA]: Jurisdiction.LOTBA,
  [Country.ROMANIA]: Jurisdiction.ONJN,
  [Country.CANADA]: Jurisdiction.AGCO,
  [Country.ESTONIA]: Jurisdiction.EMTA
};
class JurisdictionService {
  constructor(countryService, configService, countryToJurisdiction, defaultJurisdiction) {
    this.countryService = countryService;
    this.configService = configService;
    this.countryToJurisdiction = countryToJurisdiction ? countryToJurisdiction : COUNTRY_TO_JURISDICTION;
    this.defaultJurisdiction = defaultJurisdiction ? defaultJurisdiction : Jurisdiction.MGA;
    this.registerJurisdictionEvents();
    this.registerJurisdictionQuery();
    this.registerJurisdictionChanges();
    this.registerFormQuery();
    this.moduleService = new JurisdictionModulesService(this.defaultJurisdiction);
  }
  getJurisdictionByCountry(country) {
    return this.countryToJurisdiction[country] || this.defaultJurisdiction;
  }
  registerJurisdictionQuery() {
    window.queryBus.subscribe(USER_JURISDICTION_QUERY, () => __async(this, null, function* () {
      const country = yield window.queryBus.query(USER_COUNTRY_QUERY);
      return this.getJurisdictionByCountryV2(country);
    }));
    window.queryBus.subscribe(COUNTRY_JURISDICTION_QUERY, (event) => {
      const country = event.payload;
      return this.getJurisdictionByCountryV2(country);
    });
  }
  registerJurisdictionChanges() {
    window.eventBus.subscribe(USER_COUNTRY_UPDATED, (event) => {
      const country = event.payload;
      const jurisdiction = this.getJurisdictionByCountryV2(country);
      window.eventBus.publish(USER_JURISDICTION_UPDATED, jurisdiction);
    }, { replay: true });
  }
  registerFormQuery() {
    window.queryBus.subscribe(JURISDICTION_FORM_QUERY, (event) => __async(this, null, function* () {
      var _a;
      const nextButtonEnabled = !!((_a = event.payload) == null ? void 0 : _a.nextButtonEnabled);
      return yield this.moduleService.getJurisdictionFormConfig(nextButtonEnabled);
    }));
  }
  getJurisdictionByCountryV2(country) {
    if (!country) {
      return this.defaultJurisdiction;
    }
    const config = this.configService.getConfig();
    if ((config == null ? void 0 : config.jurisdiction) && (config == null ? void 0 : config.jurisdiction[country])) {
      return config.jurisdiction[country];
    }
    return this.getJurisdictionByCountry(country);
  }
  registerJurisdictionEvents() {
    window.eventBus.register(USER_JURISDICTION_UPDATED, {
      type: "string",
      enum: Object.values(Jurisdiction)
    });
  }
}

export { COUNTRY_TO_JURISDICTION, JURISDICTION_FORM_QUERY, JurisdictionService };
